var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "c-basket", attrs: { "aria-label": "Shop basket" } },
    [
      _c("slide-in-overlay", {
        attrs: { "is-open": _vm.isOpen },
        on: { close: _vm.close },
        scopedSlots: _vm._u([
          {
            key: "heading",
            fn: function() {
              return [_vm._v(" " + _vm._s(_vm.translations["Cart"]) + " ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [_c("cart-items")]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("div", { staticClass: "o-summary" }, [
                  _c("div", { staticClass: "o-summary__shipping" }, [
                    _c("span", [_vm._v(_vm._s(_vm.translations["Shipping"]))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.cart.shippingCost))])
                  ]),
                  _vm._v(" "),
                  _vm.cart.totalDiscount
                    ? _c("div", { staticClass: "o-summary__shipping" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.translations["Discount"]))
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.cart.totalDiscount))])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-summary__total" }, [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.translations["Price in total"]))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.cart.priceInclVat))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-basket__buttons" }, [
                  _c(
                    "a",
                    {
                      staticClass: "o-btn o-btn--fullwidth",
                      attrs: { href: _vm.siteUrl + "shop/checkout" }
                    },
                    [_vm._v(_vm._s(_vm.translations["Go to checkout"]))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "o-btn o-btn--transparent o-btn--fullwidth",
                      attrs: { href: _vm.siteUrl + "shop/cart" }
                    },
                    [_vm._v(_vm._s(_vm.translations["View cart"]))]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }